export default __webpack_public_path__ + "static/media/5.75cddce9.png";